import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
  selector: "evrideo-checkbox",
  templateUrl: "./checkbox.component.html",
  styleUrls: ["./checkbox.component.scss"],
})
export class CheckboxComponent implements OnInit {
  @Input("active")
  active: boolean;

  @Input("color")
  color: string = "#A1A1A1";

  @Input("top")
  top: string = "-3px";

  @Output("activeChange")
  activeChange: EventEmitter<boolean> = new EventEmitter();

  @Output()
  checked = new EventEmitter<void>();

  constructor() {}

  ngOnInit() {}

  toggle() {
    this.active = !this.active;
    this.activeChange.emit(this.active);
    this.checked.emit();
  }
}
